import {
  type Breakdown,
  LIMITED_CONCURRENT_BREAKDOWNS,
  SINGLE_SELECT_BREAKDOWNS,
} from 'lumen/utils/constants/pi-constant-values';

const MAX_CONCURRENT_SELECTIONS = 15;

// Checks if a SINGLE_SELECT_BREAKDOWNS filter is already selected (max 1 filter)
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function limitReached(
  currentFilters: Record<Breakdown, string[]>,
  requestedSegmentation: Breakdown,
) {
  if (
    SINGLE_SELECT_BREAKDOWNS.indexOf(requestedSegmentation) > -1 &&
    currentFilters[requestedSegmentation]
  ) {
    const currentFilter = currentFilters[requestedSegmentation];
    return currentFilter.length >= 1;
  }

  return false;
}

// Checks max concurrency for LIMITED_CONCURRENT_BREAKDOWNS
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function maxConcurrencyReached(
  currentFilters: Record<Breakdown, string[]>,
  requestedSegmentation: Breakdown,
) {
  // Only prevent the selection when it's one of the LIMITED_CONCURRENT_BREAKDOWNS
  if (LIMITED_CONCURRENT_BREAKDOWNS.indexOf(requestedSegmentation) > -1) {
    let concurrentFilters = 0;
    // Sum the total active selections for LIMITED_CONCURRENT_BREAKDOWNS
    LIMITED_CONCURRENT_BREAKDOWNS.forEach((segmentation) => {
      if (currentFilters[segmentation]) {
        concurrentFilters += currentFilters[segmentation].length;
      }
    });

    return concurrentFilters >= MAX_CONCURRENT_SELECTIONS;
  }

  return false;
}

// Combines the conditions above to check if you can add a filter at all
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function canAddParityFilter(
  currentFilters: Record<Breakdown, string[]>,
  breakdown: Breakdown,
) {
  const isLimitReached = limitReached(currentFilters, breakdown);
  const isMaxConcurrencyReached = maxConcurrencyReached(
    currentFilters,
    breakdown,
  );
  return !isLimitReached && !isMaxConcurrencyReached;
}
